import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  Paper,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ENDPOINT } from "../../../endpoints/endpoints";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LiveCategoryCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
  });

  const [loading, setLoading] = useState(false);

  // 🔹 Token Checking
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.warning("Please log in to continue");
      navigate("/login");
    }
  }, [navigate]);

  // 🔹 Handle Text Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // 🔹 Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        toast.error("You must log in first!");
        navigate("/login");
        return;
      }

      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      const response = await axios.post(ENDPOINT.LIVECATEGORY_CREATE, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      const msg = response.data.message || "Unknown response";
      if (response.data) {
        toast.success(msg);
        setTimeout(() => navigate("/livecategory/list", { state: { toastMessage: msg } }), 1200);
      } else {
        toast.error(msg);
      }
    } catch (err) {
      console.error("Error creating livecategory:", err);
      const backendMsg =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Something went wrong.";
      toast.error(backendMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <ToastContainer position="top-right" autoClose={3000} />

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          🖼 Create New Live Category 
        </Typography>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <Stack spacing={2}>
            {/* English Title */}
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              required
            />

            {/* Submit Button */}
            <Box textAlign="right" mt={2}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={loading}
                sx={{ px: 4, textTransform: "none" }}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Create LiveCategory"}
              </Button>
            </Box>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default LiveCategoryCreate;
